import { Location, NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BlockUI, NgBlockUI, BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/@theme/@components';
import { Store } from '@ngrx/store';
import { AppState } from './../../../@store/app.reducers';
import { ActivarLoadingAction, DesactivarLoadingAction } from './../../../@store/actions/ui.actions';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActualizaDatosService } from 'src/app/services/auth/actualiza-datos/actualiza-datos.service';
import { RestablecerContrasenaService } from 'src/app/services/auth/restablecer-contrasena/restablecer-contrasena.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatFormField, MatSuffix, MatError, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

interface IResponseValidaContrasena {
  datos: Validacion[];
  validacion: boolean;
  errorDescripcion: string;
}

interface Validacion {
  IdValidacion: number;
  Descripcion: string;
}

@Component({
    selector: 'app-snackbar-actualiza-datos',
    template: `
    <div class="text-small" [innerHTML]="data.html"></div>
  `,
    styles: ['.text-small {font-size : 12px !important}'],
    standalone: false
})
export class SnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBar: MatSnackBar) {
  }
}

@Component({
    selector: 'app-restablecer-vigencia',
    templateUrl: './restablecer-vigencia.component.html',
    styleUrls: ['./restablecer-vigencia.component.scss'],
    imports: [BlockUIModule, FormsModule, ReactiveFormsModule, MatFormField, NgClass, MatInput, MatIconButton, MatSuffix, MatIcon, MatError, MatHint, MatButton]
})
export class RestablecerVigenciaComponent implements OnInit {
  @BlockUI() blockUI?: NgBlockUI | any;
  public blockTemplate = BlockTemplateComponent;
  public subsReduxUI = new Subscription();
  public template: string = 'corporativo';
  public formDesbloqueaUsuario: FormGroup;
  public hide2 = true;
  public hide3 = true;
  public hide4 = true;
  public imagen: string = '';
  public usuarioPrevio: string;
  public generaErrorPasswordForm = false;
  public valGuardar=false;
  public Cuenta:any;
  public actualizaDatos$: Subscription;
  public tipoRecuperacion: 'porVencer' | 'expirada' = 'porVencer';  
  
  constructor(
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private actDatosService: ActualizaDatosService,
    private restablecerContrasenaService : RestablecerContrasenaService,
    private router: Router,
    private location: Location,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.subsReduxUI = this.store.select('ui').subscribe(data => {      
      if (data.block.isLoading !== null && data.block.isLoading !== undefined) {        
        data.block.isLoading ? (this.blockUI.isActive ? null : this.blockUI.start(data.block.message || 'Cargando...')) : this.blockUI.stop();
      }
    });
    
    const tipo = history.state.tipo;
    this.tipoRecuperacion = tipo === 'porVencer'
    ? 'porVencer'
    : 'expirada';

    this.cargarFormularioUsuario();
    this.cargarUsuario();
    this.cargarPagina();
  }

  private cargarFormularioUsuario() {

    this.formDesbloqueaUsuario = new FormGroup({
      data: new FormControl('', Validators.required),
      usuario: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      password2: new FormControl('', Validators.required),
    });

    this.formDesbloqueaUsuario.controls['password2'].setValidators([
      Validators.required,
      this.noIgual.bind(this.formDesbloqueaUsuario)
    ]);
  }

  private cargarPagina() {
    this.imagenAleatoria();
    this.formDesbloqueaUsuario.get('password').valueChanges.pipe(debounceTime(2000), distinctUntilChanged()).subscribe((pass: string) => {
      if (pass.length > 0) this.validarContrasena(pass);
    });
  }

  private async cargarCuenta(): Promise<any> {
    try {
        const resp = await this.authService.tipoCuenta(this.usuarioPrevio).toPromise();
        if (resp) {
          this.Cuenta = Object.assign(resp);
        }
        return resp;
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: "No pudimos cargar el tipo de cuenta"
        });
    }
  }

  public cargarUsuario() {
    this.actualizaDatos$ = this.actDatosService.currentValue.subscribe(async valorUsuario => {
      if (valorUsuario){
        this.usuarioPrevio = valorUsuario;
        this.formDesbloqueaUsuario.patchValue({ data: this.usuarioPrevio });
        if (this.usuarioPrevio) this.formDesbloqueaUsuario.patchValue({ usuario: this.usuarioPrevio });
        await this.cargarCuenta();
      } 
      else
        this.router.navigate(['login']);
    });
  }

  public actualizarDatos() {
    if (this.formDesbloqueaUsuario.invalid) return;
    this.store.dispatch(ActivarLoadingAction());
    const { password2, usuario, ...request } = this.formDesbloqueaUsuario.getRawValue();
    this.restablecerContrasenaService.postActivarcontrasena(request).subscribe(resp => {
      this.store.dispatch(DesactivarLoadingAction());
      this.authService.cerrarSesion();
      Swal.fire({ icon: 'success', title: `${resp?.Respuesta?.Mensaje}` });
      this.router.navigate(['/login']);
    }, (err: HttpErrorResponse) => {
      this.store.dispatch(DesactivarLoadingAction());
      this.manejarError(err);      
    });
  }

  private validarContrasena(password: string) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      password,
      usuario: (this.formDesbloqueaUsuario.get("usuario").value) ? this.formDesbloqueaUsuario.get("usuario").value : ""
    }
    this.actDatosService.postValidaContrasena(request).subscribe((resp: IResponseValidaContrasena) => {
      this.store.dispatch(DesactivarLoadingAction());
      let msgError = '';
      if (resp?.datos.length > 0) {
        this.generaErrorPasswordForm = true;
        this.valGuardar=false;
        resp.datos.forEach((element) => {
          msgError += `<li> ${element.Descripcion} </li> <br>`;
        });
        this.abrirSnackBar(msgError, `Contraseña`, 'exitoSnackbar');
      }else{
        this.generaErrorPasswordForm = false;
        this.valGuardar=true;
      }
    }, error => {
      this.store.dispatch(DesactivarLoadingAction());
      let msgError = '';
      if (error?.error) {
        if (error.error.length > 0) {
          this.generaErrorPasswordForm = false;
          this.valGuardar=false;
          error.error.forEach((element, index) => {
            if (element.Visible) msgError = index === 0 ? element.Exception : `${msgError} ${element.Exception}`;
          });
        }
        else {
          this.generaErrorPasswordForm = false;
          this.valGuardar=false;
          msgError = error?.error?.Exception;
        }
      }
      this.abrirSnackBar(msgError, `Contraseña`, 'errorSnackbar');
    });
  }

  private abrirSnackBar(mensaje: string, titulo: string, clase: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 5000,
      panelClass: clase,
      data: {
        html: mensaje
      }
    })
  }

  public noIgual(form: FormControl): { [s: string]: boolean } {
    let formLocal: any = this;
    if (form.value !== formLocal.controls['password'].value) {
      return { noIgual: true }
    }
    return null;
  }
  
  private imagenAleatoria() {
    this.imagen = `assets/img/${Math.floor((Math.random() * Math.floor(5)) + 1)}.jpg`;
    setTimeout(() => {
      this.imagenAleatoria();
    }, 30000);
  }
  
  public validarFormulario(){
    if(this.valGuardar){
      if(!this.formDesbloqueaUsuario.invalid)
        return false;
      else
        return true;
    }
      return true;
  }

  get textosRecuperacion() {
    if (this.tipoRecuperacion === 'porVencer') {
      return {
        titulo: 'Tu contraseña está por expirar.',
        descripcion: 'Tu contraseña está próxima a vencer. Te recomendamos actualizarla ahora para evitar interrupciones en el acceso a tu cuenta.'        
      };
    }

    return {
      titulo: 'Tu contraseña ha expirado.',
      descripcion: 'Por motivos de seguridad, es necesario actualizar tu contraseña para continuar accediendo al portal. Este proceso es rápido y sencillo.'
    };
  }

  public regresar() {
    if (window.history.length > 1) {
      this.location.back();
      this.cd.detectChanges();
    } else {
      this.router.navigate(['/login']);
    }
  }

  manejarError(error: HttpErrorResponse | string): void {
    let erroresVisibles: string[] = [];

    if (typeof error === 'string') {
      erroresVisibles.push(error || 'Ups, ocurrió un error inesperado.');
    } else {
      const response = error?.error;

      if (response?.Errores && Array.isArray(response.Errores)) {
        erroresVisibles = response.Errores.filter((e: any) => e.Visible).map((e: any) => e.Exception);
      }

      if (response && Array.isArray(response)) {
        erroresVisibles = response.filter((e: any) => e.Visible).map((e: any) => e.Exception);
      }

      if (erroresVisibles.length === 0) {
        erroresVisibles.push(response?.Exception[0] || 'Ups, ocurrió un error inesperado.');
      }
    }

    const htmlErrores = erroresVisibles.map(e => `<p>${e}</p>`).join('');

    Swal.fire({
      title: '¡Imposible continuar!',
      icon: 'error',
      html: htmlErrores,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    });
  }
}
